/**
 * 过滤手机号码
 * @param value
 * @returns {string|*}
 */
export default (value) => {
    if (value === undefined || value === null || value === '' || typeof value === Object) {
        return ''
    }

    let text = '';
    try {
        text = value.slice(0, 3) + "*****" + value.slice(value.length - 3, value.length)
    } catch (e) {

    }

    return text
}



// WEBPACK FOOTER //
// ./src/static/js/utils/modules/filterSjhm.js